import React, {Component} from 'react'
import { ScaleLoader } from 'react-spinners'

class LoadingSpinner extends Component {


    render() {
        const height = this.props.height || 35
        const width = this.props.width || 4
        const radius = this.props.radius || 2
        const marginTop = this.props.marginTop || "0px"
        const margin = this.props.margin || "2px"
        const className = this.props.className || ''
        const color = this.props.color || '#c5c5c5'
        const style = this.props.style || {}
        return <div className={className} style={Object.assign({
            textAlign: 'center',
            marginTop: marginTop,
        }, style)}>
            <ScaleLoader
                color={color}
                loading={true}
                height={height}
                width={width}
                radius={radius}
                margin={margin}
            />
        </div>
    }
}

export default LoadingSpinner


// WEBPACK FOOTER //
// ./src/common/spinner/loading.component.jsx